import { render, staticRenderFns } from "./DisabledPeople.vue?vue&type=template&id=dd2229e4&scoped=true&"
import script from "./DisabledPeople.vue?vue&type=script&lang=js&"
export * from "./DisabledPeople.vue?vue&type=script&lang=js&"
import style0 from "./DisabledPeople.vue?vue&type=style&index=0&id=dd2229e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2229e4",
  null
  
)

export default component.exports